import { useState, type FormEvent } from 'react'
import { api, ApiFehler } from '../api'

export function Anmeldung({ onAngemeldet }: { onAngemeldet: () => void }) {
  const [benutzername, setBenutzername] = useState('')
  const [passwort, setPasswort] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [laeuft, setLaeuft] = useState(false)
  const [vergessen, setVergessen] = useState(false)
  const [resetGesendet, setResetGesendet] = useState(false)

  const absenden = async (e: FormEvent) => {
    e.preventDefault()
    setLaeuft(true)
    setFehler(null)
    try {
      await api.anmelden(benutzername, passwort)
      onAngemeldet()
    } catch (err) {
      setFehler(err instanceof ApiFehler && err.status === 401 ? 'Benutzername oder Passwort falsch.' : String((err as Error).message))
    } finally {
      setLaeuft(false)
    }
  }

  const resetAnfordern = async (e: FormEvent) => {
    e.preventDefault()
    setFehler(null)
    try {
      await api.passwortVergessen(benutzername)
      setResetGesendet(true)
    } catch (err) {
      setFehler((err as Error).message)
    }
  }

  const zurueck = () => {
    setVergessen(false)
    setResetGesendet(false)
    setFehler(null)
  }

  if (vergessen)
    return (
      <div className="anmeldung">
        <form onSubmit={resetAnfordern}>
          <img src="/favicon.svg" alt="" width={72} height={72} />
          <h1>meine Perlen</h1>
          {resetGesendet ? (
            <p>Falls es den Benutzer gibt und eine bestätigte E-Mail-Adresse hinterlegt ist, ist ein Link zum Zurücksetzen unterwegs. Er ist 2 Stunden gültig.</p>
          ) : (
            <>
              <p>Wir schicken dir einen Link an deine bestätigte E-Mail-Adresse.</p>
              <label>
                Benutzername
                <input value={benutzername} onChange={(e) => setBenutzername(e.target.value)} autoComplete="username" autoCapitalize="none" autoFocus required />
              </label>
              {fehler && <p className="fehler">{fehler}</p>}
              <button type="submit" disabled={!benutzername}>
                Link anfordern
              </button>
            </>
          )}
          <button type="button" className="link" onClick={zurueck}>
            Zurück zur Anmeldung
          </button>
        </form>
      </div>
    )

  return (
    <div className="anmeldung">
      <form onSubmit={absenden}>
        <img src="/favicon.svg" alt="" width={72} height={72} />
        <h1>meine Perlen</h1>
        <label>
          Benutzername
          <input value={benutzername} onChange={(e) => setBenutzername(e.target.value)} autoComplete="username" autoCapitalize="none" required />
        </label>
        <label>
          Passwort
          <input type="password" value={passwort} onChange={(e) => setPasswort(e.target.value)} autoComplete="current-password" required />
        </label>
        {fehler && <p className="fehler">{fehler}</p>}
        <button type="submit" disabled={laeuft}>
          Anmelden
        </button>
        <button type="button" className="link" onClick={() => setVergessen(true)}>
          Passwort vergessen?
        </button>
      </form>
    </div>
  )
}
